import { render, staticRenderFns } from "./PayerActivateAction.vue?vue&type=template&id=83f2b560&scoped=true"
import script from "./PayerActivateAction.vue?vue&type=script&lang=js"
export * from "./PayerActivateAction.vue?vue&type=script&lang=js"
import style0 from "./PayerActivateAction.vue?vue&type=style&index=0&id=83f2b560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f2b560",
  null
  
)

export default component.exports